import locale from "@bonliva-crm/locale";
import { UserSearchSingle } from "@consultants/consultant-profile-new/user-search/user-search-single";
import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Controller, UseFormReturn } from "react-hook-form";
import { ReassignBaActionFormValues } from "./action-form-values";

type Props = {
  form: UseFormReturn<ReassignBaActionFormValues, any, ReassignBaActionFormValues>;
};

export const ReassignBaAction = ({ form: { control, watch, resetField } }: Props) => {
  const classes = useStyles();
  const resetResponsiblePerson = watch("resetResponsiblePerson");

  return (
    <FormControl component="fieldset" className={classes.root}>
      <Grid
        container
        direction={"column"}
        style={{ rowGap: "1.5rem", marginTop: "16px" }}
      >
        <Controller
          render={({ field }) => (
            <Grid item className={classes.messageContainer}>
              <FormLabel>
                <Typography variant="body1">{`${locale["Responsible HBA"]}:`}</Typography>
              </FormLabel>
              <UserSearchSingle
                {...field}
                autoFocus={false}
                isDisabled={!!resetResponsiblePerson}
              />
            </Grid>
          )}
          name="responsiblePerson"
          control={control}
        />

        <Divider />

        <Controller
          render={({ field }) => (
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={field.value}
                    onChange={(e) => {
                      resetField("responsiblePerson");
                      field.onChange(e);
                    }}
                  />
                }
                label={locale.resetResponsibleHBA}
              />
            </Grid>
          )}
          name="resetResponsiblePerson"
          control={control}
        />
      </Grid>
    </FormControl>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0.5rem"
  },
  textContainer: {
    display: "flex",
    flexDirection: "row",
    columnGap: "0.5rem",
    alignItems: "center"
  },
  messageContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  }
}));
